export default "__VITE_ASSET__DQWpKwd2__"